import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AuthContext from "../../contexts/AuthCtx";
import { toast } from "../../utils/toast";

/**
 * Stripe cancel_url lands here. No error modal — return to the dashboard.
 */
const PaymentError = () => {
  const navigate = useNavigate();
  const { updateHandler } = useContext(AuthContext);

  useEffect(() => {
    updateHandler();
    toast.info("Paiement annulé. Tu peux réessayer quand tu veux.");
    navigate("/dashboard", { replace: true });
  }, [navigate, updateHandler]);

  return null;
};

export default PaymentError;
